export default __webpack_public_path__ + "static/media/cars (3).60a5a591.png";